//
export interface IFiltersMixin {
  methods: {
    $n?: (value: number, style: string, locale: string) => string;
    currency(value: number | string): string;
    hideNumbers(value: string): string;
  };
}

export const filters: IFiltersMixin = {
  methods: {
    currency(value: number | string): string {
      return (
        this.$n?.(typeof value === 'string' ? parseFloat(value) : value, 'currency', 'en_US') ?? ''
      );
    },
    hideNumbers(value: string): string {
      if (value.length > 5) {
        return (
          value.substring(0, value.length - 4).replace(/\d/g, '*') +
          value.substring(value.length - 4)
        );
      } else if (value.length === 2) {
        return (
          value.substring(0, value.length - 1).replace(/\d/g, '*') +
          value.substring(value.length - 1)
        );
      }
      return (
        value.substring(0, value.length - 2).replace(/\d/g, '*') + value.substring(value.length - 2)
      );
    },
  },
};
